export type Timeframe = 'this_week' | 'this_month' | 'this_year' | 'all_time';

export const TIMEFRAMES: { key: Timeframe; label: string }[] = [
  { key: 'this_week', label: 'This Week' },
  { key: 'this_month', label: 'This Month' },
  { key: 'this_year', label: 'This Year' },
  { key: 'all_time', label: 'All Time' },
];

const EPOCH = '1970-01-01T00:00:00.000Z';

/** Returns ISO since/until for a timeframe. `now` is injectable for tests. */
export function getTimeframeRange(
  tf: Timeframe,
  now: Date = new Date(),
): { since: string; until: string } {
  const until = now.toISOString();

  if (tf === 'all_time') {
    return { since: EPOCH, until };
  }
  if (tf === 'this_year') {
    return { since: new Date(now.getFullYear(), 0, 1).toISOString(), until };
  }
  if (tf === 'this_month') {
    return { since: new Date(now.getFullYear(), now.getMonth(), 1).toISOString(), until };
  }
  // this_week — Monday 00:00 local
  const day = now.getDay(); // 0 = Sun
  const daysSinceMonday = (day + 6) % 7;
  const monday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - daysSinceMonday);
  return { since: monday.toISOString(), until };
}

/** Sort rows desc by accessor, tie-break by name asc, drop zero/negative, cap at n. */
export function topN<T>(
  rows: T[],
  accessor: (row: T) => number,
  name: (row: T) => string,
  n = 5,
): T[] {
  return rows
    .filter((r) => accessor(r) > 0)
    .sort((a, b) => {
      const diff = accessor(b) - accessor(a);
      return diff !== 0 ? diff : name(a).localeCompare(name(b));
    })
    .slice(0, n);
}
